import { render, staticRenderFns } from "./radioB.vue?vue&type=template&id=24ae0607&scoped=true"
import script from "./radioB.vue?vue&type=script&lang=js"
export * from "./radioB.vue?vue&type=script&lang=js"
import style0 from "./radioB.vue?vue&type=style&index=0&id=24ae0607&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae0607",
  null
  
)

export default component.exports